import React, { ReactNode, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "@app/routing";
import { getUpsLocalStorage } from "@app/ups/utils/localStorage";

interface UPSTokenExpiryWatcherProps {
  children: ReactNode;
  expireTime: number | null;
}

const UPSTokenExpiryWatcher: React.FC<UPSTokenExpiryWatcherProps> = ({
  children,
  expireTime,
}) => {
  const authType = getUpsLocalStorage("authType");
  const guestToken = getUpsLocalStorage("guestToken");
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (authType !== "guest") return;
    if (!expireTime) return;

    const now = Date.now();
    const fiveMinutesBefore = expireTime - 300_000; // 5 minutes before expiry time
    const delay = fiveMinutesBefore - now;
    const path = `${routes.upsGuestLogin}?guest_token=${guestToken}`;

    if (delay <= 0) {
      navigate(path ?? routes.logIn);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      navigate(path ?? routes.logIn);
    }, delay);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [expireTime, navigate]);

  return <>{children}</>;
};

export default UPSTokenExpiryWatcher;
